<template>
  <div>
    <div class="about flex mt-2">
      <div class="grid--lg-33 grid--sml-100 ttl">
        <span class="ttu m-t2">About</span> <br>
        Field Experiments is a nomadic design collective that explores traditional crafts by engaging in collaborative making with local craftspeople in diverse regions around the world. Underpinned by cross-cultural exchange, we produce projects, products and ideas across multiple formats including furniture, clothing, video works, publications, exhibitions, interiors, installation and printed materials. <br><br> <span class="ttu">Field Experiments was founded in 2013</span>
      </div>
      <div class="grid--lg-33 grid--sml-100">
        Designers <br>
        ● Benjamin Harrison Bryant <br>
        ● Paul Marcus Fuog <br>
        ● Karim Charlebois-Zariffa<br> <br>
        CONTACT FOR<br>
        ● Press <br> ● New commissions <br> ● Workshops<br> ● Presentations <br> ● Collaborations <br> <br> <a href="mailto:mail@field-experiments.com">mail@field-experiments.com</a>
      </div>
      <div class="grid--lg-33 grid--sml-100 m-mt">
        <span class="m-t2">Exhibitions</span> <br>
        ● The Design Museum (UK) <br>
        ● Fisher Parish Gallery (USA) <br>
        ● Ventura Lambrate (ITA) <br>
        ● Sight Unseen OFFSITE (USA)<br>
        ● DesignEx (AUS)<br>
        <br>
        Presentations and workshops <br>
        ● Otis College of Art and Design (USA) <br>
        ● Semi-Permanent (NZ) <br>
        ● Monash University Art Design and Architecture (AUS) <br>
        ● Design As Activity (AUS) <br><br>
        Press <br>
        ● PIN-UP <br>
        ● Surface Magazine <br>
        ● Elle Décor Italy <br>
        ● New York Times Magazine <br>
        ● Dwell Magazine <br>
        ● Sight Unseen <br>
        ● Another Magazine <br>
        ● Alldayeveryday
      </div>
    </div>
    <div class="footer p mt-2 mb-1">
      <span>Follow on <a href="https://www.instagram.com/fieldexperiments">Instagram</a>. </span>
      <span><a href="https://confirmsubscription.com/h/t/D251C439679F6EF4" target="_blank">Sign up</a> to Newsletter. </span>
      <span><a href="mailto:mail@field-experiments.com">Contact us</a>. </span>
      <span>Copyright Field Experiments {{ new Date().getFullYear() }}. </span>
    </div>
</div>
</template>

<script>


export default {
  name: 'about'
}
</script>

<style lang="scss">
.about {
  .ttl {
    text-transform: initial;
  }
  .ttu {
    text-transform: uppercase;
  }
  .m-mt {
    @include media_query(mobile-port) {
      margin-top: 4rem;
    }
  }
}
.footer {
  @include media_query(mobile-port) {
    font-size: 24px;
  }
  span {
    @include media_query(mobile-port) {
      display: block;
      width:100%;
    }
  }
  a {
    color: gray;
  &:hover{
    color: gray;
    cursor: pointer;
  }
}
}
</style>
